<template>
    <div
        v-if="mode === 'soft'"
        class="w-full border-b border-warn bg-warn text-neutral-900"
        role="status"
    >
        <div class="mx-auto flex max-w-7xl items-start gap-3 px-4 py-2 text-sm sm:items-center sm:px-6 lg:px-8">
            <LockIcon class="mt-0.5 h-4 w-4 shrink-0 sm:mt-0" aria-hidden="true"/>
            <p>
                <strong class="font-semibold">{{ t('title') }}</strong>
                {{ t('body') }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
const { mode } = useMaintenance()
const { t } = useI18n({ useScope: 'local' })
</script>

<i18n lang="yaml">
en:
    title: The CMS is temporarily in maintenance mode.
    body: You can view all content, but nothing can be changed until maintenance is finished.
nl:
    title: Het CMS is tijdelijk in onderhoudsmodus.
    body: Je kunt alle content bekijken, maar er kan niets gewijzigd worden totdat het onderhoud klaar is.
</i18n>
